const isClient = () => {
  if (typeof window !== 'undefined') {
    return true
  }
  return false
}

export const makeFinishUrl = (
  hash: string,
  params?: { [k: string]: string }
) => {
  return `/finish/${hash}${
    params
      ? '?' +
        Object.keys(params)
          .map((k) => `${k}=${params[k]}`)
          .join('&')
      : ''
  }`
}

export const makeHomeUrl = () => {
  return '/'
}

export const makeNFTUrl = () => {
  return '/nft'
}

export const makeTokenUrl = () => {
  return '/token'
}

export const makeTokenInfoUrl = (address: string) => {
  return `/token/${address.replace(/#/g, '%23')}`
}

export const makeTokenEditUrl = (address: string) => {
  return `/token/edit/${address.replace(/#/g, '%23')}`
}

export const makeDioscanTxnUrl = (hash: string) => {
  if (!isClient()) return ''
  return `${window.DioscanDomain}/blockchain/transactions/${hash}`
}

export const makeDioscanAddressUrl = (address: string) => {
  if (!isClient()) return ''
  const [name, type] = address.split(':')
  let link: string = window.DioscanDomain || ''
  switch (type) {
    case 'token':
      link += `/assets/token/${address.replace(/#/g, '%23')}`
      break
    case 'dapp':
      link += `/dapp/${address.replace(/#/g, '%23')}`
      break
    default:
      link += `/assets/address/${address}`
  }
  return link
}

export const makeDioscanNFTIDUrl = (serie: number, id: string) => {
  if (!isClient()) return ''
  return `${window.DioscanDomain}/assets/nft/${serie}-${id}`
}

export const makeNFTIDInfoUrl = (serie: number, id: string | number) => {
  return `/nft/id/${serie}-${id}`
}

export const makeNFTAddressInfoUrl = (address: string) => {
  return `/nft/${address.replace(/#/g, '%23')}`
}

export const makeNFTEditUrl = (address: string) => {
  return `/nft/edit/${address.replace(/#/g, '%23')}`
}

export const makeDAppUrl = () => {
  return '/dapp'
}

export const makeDioxscanDAppUrl = (dapp: string) => {
  if (!isClient()) return ''
  return `${window.DioscanDomain}/dapp/${dapp.replace(/#/g, '%23')}:dapp`
}

export const makeDioscanContractInfoUrl = (dapp: string, name: string) => {
  if (!isClient()) return ''
  return `${window.DioscanDomain}/dapp/${dapp.replace(
    /#/g,
    '%23'
  )}:dapp/contract/${dapp}.${name}`
}

export const makeDAppInfoUrl = (address: string) => {
  return `/dapp/${address.replace(/#/g, '%23')}`
}

export const makeDAppEditUrl = (address: string) => {
  return `/dapp/edit/${address.replace(/#/g, '%23')}`
}
